export default "__VITE_ASSET__4NONw3q___"